<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="车辆分类:" >
          <el-select  v-model="searchFrom.trailerFlag"  placeholder="请选择">
            <el-option  label="全部" value="" ></el-option>
            <el-option  label="主车" value="0" ></el-option>
            <el-option  label="挂车" value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主/挂车号:">
          <el-input placeholder="" v-model="searchFrom.vhcNo" ></el-input>
        </el-form-item>
         <el-form-item label="能源类型:" >
              <el-select placeholder="请选择" v-model="searchFrom.energyName">
                 <el-option  label="全部" value="" ></el-option>
                <el-option
                  v-for="item in NYtype"
                  :key="item.id"
                  :label="item.energyName"
                  :value="item.energyName"
                ></el-option>
              </el-select>
          </el-form-item>
        <el-form-item label="所属队组:" class="item2 dzBox">
          <div style="display: flex;">
          <el-select   v-model="searchFrom.teamOrgId" filterable placeholder="请选择" clearable   @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <el-select   v-model="searchFrom.operationOrgId " filterable placeholder="请选择" clearable   >
            <el-option v-for="item in XZList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
          </div>
        </el-form-item>
        <el-form-item label="保险类型" >
          <el-select  v-model="searchFrom.insuranceProject" filterable    >
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in LXlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否到期" >
          <el-select  v-model="searchFrom.overdueFlag" filterable    >
            <el-option  label="全部" value="" ></el-option>
            <el-option  label="未到期" value="0" ></el-option>
            <el-option  label="已到期" value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间:" class="item2" >
          <el-date-picker
              v-model="searchFrom.createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]"  size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"   size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[1]"  @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-button type="primary" v-if="btnFlg[2]"  @click="addFn" size="mini" >新增</el-button>
            <el-button type="primary" v-if="btnFlg[3]"  @click="delFn" size="mini" >删除</el-button>
            <el-button type="primary" v-if="btnFlg[4]"  @click="importFn" size="mini" >导入</el-button>
            <el-button type="primary" v-if="btnFlg[4]"  @click="modelDown">模板下载</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change="selectGoods" @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border :cell-style="getCellStyle">
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="110" >
          <template slot-scope="scope">
            <div>
              <el-button  type="text" size="mini" v-if="btnFlg[5]" @click="editFn(scope.row)">修改</el-button>
              <el-button  type="text" size="mini"  @click="pingzhengFn(scope.row)">凭证</el-button>
            </div>
          </template>
        </el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="vhcNo" label="主/挂车号" align="center"
             min-width="100"></el-table-column>
       <el-table-column prop="energyName" width="100"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty"  label="能源类型"></el-table-column>
       <el-table-column prop="brandModel" width="100"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty"  label="品牌"></el-table-column>
       <el-table-column prop="vehicleModel" width="100"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty" label="型号"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="teamOperationName" label="所属队组" align="center" width="100"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="insuranceProject" label="保险类型" align="center"  width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="overdueRemind" label="到期提醒"  min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="firstPaymentAmount" label="首款金额"  min-width="80" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="firstPaymentDateString" label="首款日期"  min-width="100" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="accountPeriod" label="账期"  min-width="80" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="installmentPaymentAmount" label="分期付款金额"  min-width="110" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="repaymentDate" label="还款日"  min-width="80" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="balancePaymentAmount" label="尾款总额"  min-width="80" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="insuranceCosts" label="保险总额"  min-width="80" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="insuranceCompany" label="保险公司"  min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="effectiveDate" label="生效起止日期" align="center"  min-width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center"
          min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" min-width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog  :title="isAdd?'添加':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="90%" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="addForm" :model="addForm" class="demo-form-inline jiaoyan"  label-width="110px" size="mini" v-if="addFlag">
          <el-form-item label="主/挂车号:" prop="vehicleId" class="width1" >
            <el-select v-model="addForm.vehicleId" filterable placeholder="请选择" v-if="isAdd" @change="cheChange">
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcId" :key="item.vhcId"></el-option>
            </el-select>
            <span>{{addForm.vhcNo}}</span>
          </el-form-item>
          <br>
          <el-form-item label="品牌:" >
            <span>{{addForm.brandModel?addForm.brandModel:'-'}}</span>
          </el-form-item>
            <el-form-item label="型号:" >
            <span>{{addForm.vehicleModel?addForm.vehicleModel:'-'}}</span>
          </el-form-item>{{addForm.trailerFlag}}
           <el-form-item label="能源类型:"   prop="energy" >
              <span>{{addForm.energyName}}</span>
          </el-form-item>
          <br>
           <el-table :data="addForm.insuranceList" class="bxBox" bordersize="mini" style="width: 100%" max-height="500px" center border v-if="addFlag">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
                  <el-button type="text" size="mini" @click="addGoodFn(scope.row)">追加</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="保险公司" min-width="120">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceCompany'" :key="scope.$index"  class="table_error">
                    <el-input placeholder="" maxlength="50"
                      v-model.trim="addForm.insuranceList[scope.$index].insuranceCompany" ></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="保险类型" min-width="160">
              <template slot="header" >
                <div><span class="red">*</span>保险类型</div>
              </template>
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceProject1'" :key="scope.$index+'insuranceProject1'" :rules="rules.insuranceProject1" class="table_error">
                    <el-select  v-model="addForm.insuranceList[scope.$index].insuranceProject1" filterable  multiple    @change="bxlxChange(scope.row,$event)" >
                      <el-option v-for="item in LXlist" :label="item.showName+'('+item.ext1+')'" :value="item.showName" :key="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="首款金额" min-width="80">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.firstPaymentAmount'" :key="scope.$index+'firstPaymentAmount'" class="table_error">
                    <el-input placeholder="" maxlength="10" v-number-input.float="2"
                      v-model.trim="addForm.insuranceList[scope.$index].firstPaymentAmount" @change="jisuanFN(scope.row)"></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="首款日期" width="150">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.firstPaymentDate'" :key="scope.$index+'firstPaymentDate'" class="table_error">
                    <el-date-picker  v-model="addForm.insuranceList[scope.$index].firstPaymentDate"  format="yyyy-MM-dd"   value-format="timestamp" @change="jisuanFN(scope.row)"
                      type="date"   ></el-date-picker>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="账期" min-width="80">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.accountPeriod'" :key="scope.$index+'accountPeriod'"  class="table_error">
                    <el-input placeholder="" maxlength="10" v-number-input.float="0"
                      v-model.trim="addForm.insuranceList[scope.$index].accountPeriod"  @change="jisuanFN(scope.row)"></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="分期付款金额" min-width="110">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.installmentPaymentAmount'" :key="scope.$index+'installmentPaymentAmount'"  class="table_error jiage">
                    <el-input placeholder="" maxlength="10" v-number-input.float="2"
                      v-model.trim="addForm.insuranceList[scope.$index].installmentPaymentAmount" @change="jisuanFN(scope.row)" ></el-input>
                      <span class="danwei">{{scope.row.settlementUnit}}</span>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="每月还款日" min-width="100">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.repaymentDate'" :key="scope.$index+'repaymentDate'"  class="table_error">
                    <el-select v-model="addForm.insuranceList[scope.$index].repaymentDate" filterable  clearable   >
                      <el-option v-for="n in 31" :key="n" :label="n" :value="n" ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
             <el-table-column label="尾款总额" min-width="100">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.balancePaymentAmount'" :key="scope.$index+'balancePaymentAmount'" class="table_error">
                    <el-input placeholder="" maxlength="10" v-number-input.float="2"
                      v-model.trim="addForm.insuranceList[scope.$index].balancePaymentAmount"  :readonly="true"></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="保险总额" min-width="100">
               <template slot="header" >
                <div><span class="red">*</span>保险总额</div>
              </template>
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceCosts'" :key="scope.$index+'insuranceCosts'" :rules="rules.insuranceCosts"  class="table_error">
                    <el-input placeholder="" maxlength="10" v-number-input.float="2"
                      v-model.trim="addForm.insuranceList[scope.$index].insuranceCosts" :readonly="scope.row.accountPeriod?true:false" ></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="保单起止日期" width="300">
              <template slot="header" >
                <div><span class="red">*</span>保单起止日期</div>
              </template>
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceDateFrom'" :key="scope.$index+'insuranceDateFrom'" :rules="rules.insuranceDateFrom" class="table_error">
                    <el-date-picker v-model="addForm.insuranceList[scope.$index].insuranceDateFrom" format="yyyy-MM-dd" value-format="timestamp" @change="timeChange(addForm.insuranceList[scope.$index],1)" type="date"></el-date-picker>
                  </el-form-item>
                 <div style="margin:0 4px"> -</div>
                   <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceDateTo'" :key="scope.$index+'insuranceDateTo'" :rules="rules.insuranceDateTo" class="table_error">
                    <el-date-picker v-model="addForm.insuranceList[scope.$index].insuranceDateTo"  format="yyyy-MM-dd"   value-format="timestamp" @change="timeChange(addForm.insuranceList[scope.$index],2)"
                    type="date" ></el-date-picker>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="130">
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.remark'" :key="scope.$index+'remark'"  class="table_error">
                    <el-input placeholder="" maxlength="10" v-model.trim="addForm.insuranceList[scope.$index].remark" ></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <br>
          <el-form-item label="凭证:" class="remark" prop="remark" v-if="addFlag" label-width="60px"  >
             <!-- <uploadImgs :imgList.sync='imgList' :max=10 @remove="remove"></uploadImgs> -->
             <uploadFiles :fileArr.sync='imgList' :max=10 @remove="remove"></uploadFiles>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 凭证 -->
    <el-dialog title="凭证" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="pzFlag" width="300px" center>
      <div class="fujianBox">
        <el-button type="text" v-for="item in pzList" @click="fujianClick(item)" :key="item.name">{{item.name}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="lookImgFlag"
      append-to-body width="800px" center>
      <div style="text-align: right;">
        <div id="printMe" ref="print">
          <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
        </div>
      </div>
    </el-dialog>
    <!-- 导入 -->
<importC   v-if="importDialog" danwei="M" size="5" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, dateFormat1, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { findVehicleInsuranceList, updateInsurance, imporVehicleInsurance, organizationTree, getVehicleListByDh, cVehicleInsuranceList, tOverdueSetList,
  cVhcEnergyTypeList, getFileShow } from '@/api/vgs-driver2.0'
import { getDictionaryDetailList } from '@/api/newTMS'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import importC from '@/components/import1.vue'
export default {
  components: {
    uploadFiles, importC
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      HWlist: [],
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        vehicleId: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ],
        insuranceProject1: [
          { required: true, message: '请选择保险类型', trigger: 'blur' }
        ],
        insuranceCosts: [
          { required: true, message: '请输入保费', trigger: 'blur' }
        ],
        insuranceDateFrom: [
          { required: true, message: '请选择保险开始日期', trigger: 'blur' }
        ],
        insuranceDateTo: [
          { required: true, message: '请选择保险结束日期', trigger: 'blur' }
        ]

      },
      isAdd: false,
      addFlag: false,
      addForm: { insuranceList: [{}] },
      XDList: [],
      XZList: [],
      carList: [],
      LXlist: [],
      delBxIds: [],
      importDialog: false,
      bjData: {},
      NYtype: [],
      imgList: [],
      pzFlag: false,
      pzList: [],
      lookImgFlag: false,
      imgUrl: '',
      btnFlg: [],
      btnIdArr: ['01N01Q0100', '01N01Q0200', '01N01Q0300', '01N01Q0400', '01N01Q0500', '01N01Q0600']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.searchFn()
    getDictionaryDetailList({ dictionaryType: 'vehicle_insurance_project' }).then(res => {
      this.LXlist = res
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
    })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
    getVehicleListByDh({ vhcClassify: 2 }).then(res => {
      this.carList = res
    })
    tOverdueSetList().then(res => {
      if (res.length > 0) {
        this.bjData = res[0]
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 凭证
    pingzhengFn (row) {
      getFileShow({ businessType: 'vehicleInsurance', businessId: row.vehicleId }).then(res => {
        if (res.length == 0) {
          this.$alert('暂无可查看的凭证', '系统提示')
        } else {
          this.pzList = []
          res.forEach(item => {
            var filename = item.url.split('/').pop()
            this.pzList.push({
              name: filename,
              url: item.fileKeyUrl
            })
          })
          this.pzFlag = true
        }
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.addForm.deleteAttachmentsIds.push(file.id)
      }
    },
    // 选择车辆
    cheChange (e) {
      let josn = this.carList.find(itme => itme.vhcId == e)
      console.log(josn)
      this.$set(this.addForm, 'brandModel', josn.brandModel)
      this.$set(this.addForm, 'vehicleModel', josn.vehicleModel)
      this.$set(this.addForm, 'energyName', josn.energyName)
    },
    // 金额和日期计算逻辑
    jisuanFN (row) {
      if (row.firstPaymentDate && row.accountPeriod && row.settlementUnit) {
        this.$set(row, 'insuranceDateFrom', row.firstPaymentDate)
        if (row.settlementUnit == '元/月') {
          this.$set(row, 'insuranceDateTo', addMonthsToTimestamp(row.firstPaymentDate, row.accountPeriod))
        } else {
          this.$set(row, 'insuranceDateTo', addYearsToTimestamp(row.firstPaymentDate, row.accountPeriod))
        }
      }
      if (row.firstPaymentAmount && row.accountPeriod && row.installmentPaymentAmount) {
        this.$set(row, 'balancePaymentAmount', toFixed(accMul(row.installmentPaymentAmount, row.accountPeriod), 2))
        this.$set(row, 'insuranceCosts', toFixed((Number(row.firstPaymentAmount) + Number(row.balancePaymentAmount)), 2))
      } else {
        this.$set(row, 'balancePaymentAmount', '')
      }
      function accMul (arg1, arg2) {
        var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
        try {
          m += s1.split('.')[1].length
        } catch (e) {
        }
        try {
          m += s2.split('.')[1].length
        } catch (e) {
        }

        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
      }
      function addMonthsToTimestamp (timestamp, months) {
        console.log(timestamp, months)
        months = Number(months)
        const date = new Date(timestamp)
        // 计算新的月份
        const newMonth = date.getMonth() + months
        // 设置新的月份
        date.setMonth(newMonth)

        // 处理可能出现的日期不匹配问题
        if (date.getDate() < new Date(timestamp).getDate()) {
          date.setDate(0)
        }

        return date.getTime()
      }
      function addYearsToTimestamp (timestamp, years) {
        years = Number(years)
        // 把时间戳转为 Date 对象
        const date = new Date(timestamp)
        // 增加年份
        date.setFullYear(date.getFullYear() + years)

        // 处理闰年和不同月份天数不同的情况
        // 如果新日期的日期部分小于原日期的日期部分，说明新年份该月的天数不够原日期的日期部分，将日期设置为该月最后一天
        if (date.getDate() < new Date(timestamp).getDate()) {
          date.setDate(0)
        }

        // 把更新后的 Date 对象转回时间戳
        return date.getTime()
      }
    },
    // 保险类型修改
    bxlxChange (row, e) {
      console.log(e, row)
      if (e.length > 0) {
        let arrDW = []
        e.forEach(item => {
          let json = this.LXlist.find(x => x.showName == item)
          if (json) {
            arrDW.push(json.ext1)
          }
        })
        if (new Set(arrDW).size == 1) {
          this.$set(row, 'settlementUnit', arrDW[0])
          this.$set(row, 'insuranceProject', e.toString())
          this.jisuanFN(row)
        } else {
          this.$alert('所选的保险类型汇算单位不一样，请重新选择', '系统提示')
          this.$set(row, 'insuranceProject1', null)

          this.$set(row, 'settlementUnit', null)
        }
      }
    },
    timeChange (row, n) {
      if (row.insuranceDateFrom > row.insuranceDateTo) {
        this.$alert('开始时间不能晚于结束实际', '系统提示')
        if (n == 1) {
          this.$set(row, 'insuranceDateFrom', null)
        } else {
          this.$set(row, 'insuranceDateTo', null)
        }
      }
    },
    // 超时报警颜色设置
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'overdueRemind' && row.insuranceDays <= this.bjData.zhucheInsuranceDays) {
        return { background: '#FEB0A4' }
      }
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/车辆保险导入模板.xlsx'
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      formData.append('params', JSON.stringify({ id: '' }))
      imporVehicleInsurance(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.msg = this.$message({
          showClose: true,
          message: res.message,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = {}
            exportExcel(
              this.global.driverNameT +
                    '/cVehicleInsurance/exportVehicleInsuranceExc',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data ? err.data : err.message
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data ? err.data : err.message,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 添加保险
    addGoodFn (row) {
      let json = { ...row }
      delete json.id
      this.addForm.insuranceList.push(json)
    },
    // 删除保险
    delGoodFn (index) {
      if (this.addForm.insuranceList.length == 1) {
        this.$alert('最后一条数据不能删除', '系统提示')
        return
      }
      if (this.addForm.insuranceList[index].id) {
        this.delBxIds.push(this.addForm.insuranceList[index].id)
      }
      this.addForm.insuranceList.splice(index, 1)
    },
    sijiChange (e) {
      if (e) {

      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.id == e)
        this.XZList = json[0].children
        this.$set(this.searchFrom, 'groupCode', null)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
      this.addForm = { insuranceList: [{}], deleteAttachmentsIds: [] }
    },
    // 修改
    editFn  (row) {
      this.imgList = []
      cVehicleInsuranceList({ vehicleId: row.vehicleId }).then(res => {
        this.addForm = { vehicleId: row.vehicleId, vhcNo: row.vhcNo, brandModel: row.brandModel, vehicleModel: row.vehicleModel, energyName: row.energyName }
        let arrbx = []
        res.forEach(item => {
          this.$set(item, 'insuranceCosts', item.insuranceCosts / 100)
          this.$set(item, 'firstPaymentAmount', item.firstPaymentAmount / 100)
          this.$set(item, 'installmentPaymentAmount', item.installmentPaymentAmount / 100)
          this.$set(item, 'balancePaymentAmount', item.balancePaymentAmount / 100)
          this.$set(item, 'insuranceProject1', item.insuranceProject.split(','))
          arrbx.push(item)
        })
        if (arrbx.length == 0) {
          this.$set(this.addForm, 'insuranceList', [])
        } else {
          this.$set(this.addForm, 'insuranceList', arrbx)
        }
        this.$set(this.addForm, 'deleteAttachmentsIds', [])
        getFileShow({ businessType: 'vehicleInsurance', businessId: row.vehicleId }).then(res => {
          res.forEach(item => {
            var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
            this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.fileId, name: filename })
          })
        })
      })
      this.addFlag = true
      this.isAdd = false
    },
    saveFn () {
      this.$refs.addForm.validate((valid) => {
        this.addForm.insuranceList.forEach(item => {
          item.vehicleId = this.addForm.vehicleId
        })
        this.addForm.deleteInsuranceIds = this.delBxIds.toString()
        let imgfile = new FormData()
        this.imgList.forEach(item => {
          if (!item.id) {
            imgfile.append('files', item.raw)
          }
        })
        imgfile.set('params', JSON.stringify(this.addForm))
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateInsurance(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length == 0) {
        this.$alert('请选择一要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        let imgfile = new FormData()
        imgfile.set('params', JSON.stringify({
          deleteInsuranceIds: selectData.map(item => item.id).toString()
        }))
        updateInsurance(imgfile).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.driverNameT + '/cVehicleInsurance/exportZcInsuranceList',
        form,
        '车辆保险列表'
      )

      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      this.loading = true
      findVehicleInsuranceList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.addForm = {
        deleteAttachmentsIds: []
      }
      this.imgList = []
    }

  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:340px!important;
}
/deep/.el-form{
  width: 100%;
}

.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
/deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 130px;
}
.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.fujianBox{
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
